import { TextField } from '@mui/material';
import { DropDownForPattern, dropDownStyles } from './DropDownComponent';
import { equalPatternCollections, withPatternCollections } from './FilterPatternCollection';
import { parseISO } from 'date-fns';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { PickerValue } from '@mui/x-date-pickers/internals';

interface ICustomCardProps {
  filterFieldData: any;
  handleCustomRequiredValueOnBlur: (
    val: number | string | Date,
    key: string,
    type?: string,
  ) => Promise<void>;
  handleDropDownForPatternOnChange: (event: any, key?: string) => Promise<void>;
  dataType: string;
  operator: string;
  shouldExclude: boolean;
  timeGrain?: string;
  value: string;
  inputValue: string | number | Date;
  inputValueGreaterThanOrEqualTo: string | number | Date;
  inputValueLessThanOrEqualTo: string | number | Date;
  from?: string;

  color?: string;
  backgroundColor?: string;
}

function AggregateCondition({
  filterFieldData,
  handleCustomRequiredValueOnBlur,
  handleDropDownForPatternOnChange,
  dataType,
  operator,
  shouldExclude,
  timeGrain,
  value,
  inputValue,
  color,
  backgroundColor,
  inputValueGreaterThanOrEqualTo,
  inputValueLessThanOrEqualTo,
  from = 'chartFilter',
}: ICustomCardProps) {
  var members = null;

  ///Render Search Condition Custom Input Control
  const SearchConditionCustomInputControl = ({ type }: any) => {
    return (
      <>
        <TextField
          InputProps={{
            style: {
              height: '25px',
              minWidth: '100%',
              width: '100%',
              fontSize: '13px',
              marginRight: '30px',
              textDecoration: shouldExclude ? 'line-through' : '',
              color: shouldExclude ? '#ffb74d' : 'inherit',
            },
          }}
          placeholder="Value"
          sx={{
            ...dropDownStyles.customSelect,
            paddingBottom: '8px',
            color: color,
            minWidth: '100%',
            // '& .MuiInputBase-input::placeholder': {
            //   opacity: 1,
            // },
            '& .MuiOutlinedInput-input': {
              padding: '16.5px 14px', // Consistent padding for all browsers
            },
            '& .MuiOutlinedInput-root': {
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: color,
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: color,
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: color,
              },
            },
            // Firefox-specific styling
            '@supports (-moz-appearance: none)': {
              '& .MuiOutlinedInput-input': {
                padding: '16.5px 2px 16.5px 14px',
              },
            },
          }}
          defaultValue={inputValue}
          type={type}
          onBlur={(e) =>
            handleCustomRequiredValueOnBlur(
              (e.target as HTMLInputElement).value,
              from === 'datasetFilter' ? 'lower_limit' : 'exprInput',
            )
          }
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleCustomRequiredValueOnBlur(
                (e.target as HTMLInputElement).value,
                from === 'datasetFilter' ? 'lower_limit' : 'exprInput',
              );
            }
          }}
        />

        {/* {filterFieldData.isInValidData ? (
          <span className="ErrorText">Please enter valid data.</span>
        ) : null} */}
      </>
    );
  };

  ///Render Search Condition Between Control
  const SearchConditionBetweenControl = () => {
    return (
      <>
        <TextField
          type="number"
          InputProps={{
            style: {
              height: '26px',
              width: '100%',
              minWidth: '100%',
              fontSize: '13px',
              marginRight: '30px',
              textDecoration: shouldExclude ? 'line-through' : '',
              color: shouldExclude ? '#ffb74d' : 'inherit',
            },
          }}
          className={`CustomInputValue`}
          sx={{
            ...dropDownStyles.customSelect,
            paddingBottom: '8px',
            minWidth: '100%',
            '& .MuiOutlinedInput-input': {
              padding: '16.5px 14px', //padding for all browsers
            },
            '& .MuiOutlinedInput-root': {
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: color,
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: color,
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: color,
              },
            },
            // Firefox-specific style
            '@supports (-moz-appearance: none)': {
              '& .MuiOutlinedInput-input': {
                padding: '16.5px 2px 16.5px 14px',
              },
            },
          }}
          defaultValue={inputValueGreaterThanOrEqualTo}
          onBlur={(e) => {
            handleCustomRequiredValueOnBlur(
              e.target.value,
              from === 'datasetFilter' ? 'lower_limit' : 'greaterThanOrEqualTo',
            );
          }}
        />
        <TextField
          type="number"
          InputProps={{
            style: {
              height: '26px',
              width: '100%',
              minWidth: '100%',
              fontSize: '13px',
              marginRight: '30px',
              textDecoration: shouldExclude ? 'line-through' : '',
              color: 'blue',
            },
          }}
          className={`CustomInputValue`}
          sx={{
            ...dropDownStyles.customSelect,
            paddingBottom: '8px',
            minWidth: '100%',
            '& .MuiOutlinedInput-input': {
              padding: '16.5px 14px', // Consistent padding for all browsers
            },
            '& .MuiOutlinedInput-root': {
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: color,
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: color,
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: color,
              },
            },
            // Firefox-specific styling
            '@supports (-moz-appearance: none)': {
              '& .MuiOutlinedInput-input': {
                padding: '16.5px 2px 16.5px 14px',
              },
            },
          }}
          defaultValue={inputValueLessThanOrEqualTo}
          onBlur={(e) => {
            handleCustomRequiredValueOnBlur(
              e.target.value,
              from === 'datasetFilter' ? 'upper_limit' : 'lessThanOrEqualTo',
            );
          }}
        />

        {/* {filterFieldData.isInValidData ? (
          <span className="ErrorText">Please enter valid data.</span>
        ) : null} */}
      </>
    );
  };

  ///Render Search Condition Date Between Control
  const SearchConditionDateBetween = () => {
    const lowerLimitValue =
      inputValueGreaterThanOrEqualTo === undefined
        ? new Date()
        : inputValueGreaterThanOrEqualTo instanceof Date ||
            typeof inputValueGreaterThanOrEqualTo === 'number'
          ? inputValueGreaterThanOrEqualTo
          : parseISO(inputValueGreaterThanOrEqualTo);
    const upperLimitValue =
      inputValueLessThanOrEqualTo === undefined
        ? new Date()
        : inputValueLessThanOrEqualTo instanceof Date ||
            typeof inputValueLessThanOrEqualTo === 'number'
          ? inputValueLessThanOrEqualTo
          : parseISO(inputValueLessThanOrEqualTo);
    return (
      <div className="customDatePickerWidth">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            enableAccessibleFieldDOMStructure={false}
            value={lowerLimitValue as PickerValue}
            sx={{
              '& .MuiFormControl-root': {
                width: '100%',
              },
            }}
            onChange={(e) =>
              e &&
              handleCustomRequiredValueOnBlur(
                e,
                from === 'datasetFilter' ? 'lower_limit' : 'greaterThanOrEqualTo',
                'date',
              )
            }
            slots={{
              textField: (params) => (
                <TextField
                  {...params}
                  sx={{
                    paddingBottom: '5px',
                    color: shouldExclude ? '#ffb74d' : 'inherit',
                    textDecoration: shouldExclude ? 'line-through' : '',
                    minWidth: '100%',
                    ...dropDownStyles.customSelect,
                    '& .MuiOutlinedInput-root': {
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: color,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: color,
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: color,
                      },
                    },
                  }}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      ...params.InputProps?.style,
                      color: shouldExclude ? '#ffb74d' : 'inherit',
                    },
                  }}
                  className={`customDatePickerHeight`}
                />
              ),
            }}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            enableAccessibleFieldDOMStructure={false}
            value={upperLimitValue as PickerValue}
            sx={{
              '& .MuiFormControl-root': {
                width: '100%',
              },
            }}
            onChange={(e) =>
              e &&
              handleCustomRequiredValueOnBlur(
                e,
                from === 'datasetFilter' ? 'upper_limit' : 'lessThanOrEqualTo',
                'date',
              )
            }
            slots={{
              textField: (params) => (
                <TextField
                  {...params}
                  sx={
                    shouldExclude
                      ? {
                          textDecoration: shouldExclude ? 'line-through' : '',
                          color: shouldExclude ? '#ffb74d' : 'inherit',
                          minWidth: '100%',
                          ...dropDownStyles.customSelect,
                          '& .MuiOutlinedInput-root': {
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: color,
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: color,
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: color,
                            },
                          },
                        }
                      : { minWidth: '100%', ...dropDownStyles.customSelect }
                  }
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      ...params.InputProps?.style,
                      color: shouldExclude ? '#ffb74d' : 'inherit',
                    },
                  }}
                  className={`customDatePickerHeight`}
                />
              ),
            }}
          />
        </LocalizationProvider>
        {/* {filterFieldData.isInValidData ? (
          <span className="ErrorText">Please enter valid data.</span>
        ) : null} */}
      </div>
    );
  };

  ///Render Search condition user input control
  const CustomRequiredField = () => {
    var members = null;
    if (dataType) {
      switch (dataType) {
        case 'decimal':
        case 'float':
        case 'double':
        case 'integer':
          if (operator === 'between') {
            members = <SearchConditionBetweenControl></SearchConditionBetweenControl>;
          } else {
            members = (
              <SearchConditionCustomInputControl type="number"></SearchConditionCustomInputControl>
            );
          }
          break;
        case 'text':
          members = (
            <SearchConditionCustomInputControl type="number"></SearchConditionCustomInputControl>
          );
          break;
        case 'date':
        case 'timestamp':
          if (timeGrain === 'date') {
            if (operator === 'between') {
              members = <SearchConditionDateBetween></SearchConditionDateBetween>;
            } else {
              const parsedInputValue =
                inputValue === undefined
                  ? new Date()
                  : inputValue instanceof Date || typeof inputValue === 'number'
                    ? inputValue
                    : parseISO(inputValue);
              members = (
                <div className="customDatePickerWidth">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      enableAccessibleFieldDOMStructure={false}
                      value={parsedInputValue as PickerValue}
                      onChange={(e) =>
                        e &&
                        handleCustomRequiredValueOnBlur(
                          e,
                          from === 'datasetFilter' ? 'lower_limit' : 'exprInput',
                          'date',
                        )
                      }
                      slots={{
                        textField: (params) => (
                          <TextField
                            {...params}
                            sx={
                              shouldExclude
                                ? {
                                    textDecoration: 'line-through',
                                    color: '#ffb74d',
                                    width: '100%',
                                    ...dropDownStyles.customSelect,
                                  }
                                : { width: '100%', ...dropDownStyles.customSelect }
                            }
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                ...params.InputProps?.style,
                                color: shouldExclude ? '#ffb74d' : 'inherit',
                              },
                            }}
                            className={`customDatePickerHeight`}
                          />
                        ),
                      }}
                    />
                  </LocalizationProvider>
                  {/* {filterFieldData.isInValidData ? (
                    <span className="ErrorText">Please enter valid data.</span>
                  ) : null} */}
                </div>
              );
            }
          } else {
            if (operator === 'between') {
              members = <SearchConditionBetweenControl></SearchConditionBetweenControl>;
            } else {
              members = (
                <SearchConditionCustomInputControl type="number"></SearchConditionCustomInputControl>
              );
            }
          }
          break;
        default:
          members = null;
          break;
      }
    }

    return <div>{members}</div>;
  };

  members = (
    <DropDownForPattern
      exprType={'exprType'}
      items={equalPatternCollections.filter((item) => item.key !== 'blank')}
      value={value}
      usersx={{
        marginRight: '0rem',
        right: from === 'chartFilter' ? '1px' : from === 'reportFilter' ? '4px' : '0pc',
      }}
      handleDropDownForPatternOnChange={handleDropDownForPatternOnChange}
      from={from}
      color={color}
    ></DropDownForPattern>
  );

  return (
    <div
      style={{
        backgroundColor: backgroundColor,
        display: 'flex',
        flexDirection: 'column',
        rowGap: '8px',
        marginLeft: 0,
        marginRight: 0,
        paddingTop: '2px',
      }}
    >
      {members}
      {/* Hide the custom required field if the field is parameterized */}
      {!filterFieldData.isParameterized && <CustomRequiredField />}
    </div>
  );
}

export default AggregateCondition;
